/**
 * Tuijn Code Export Timesheet Download Formatter.
 */
window.tuijncodeExportTimesheetDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/tuijncode/exports/timesheets/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
